"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferingInfoDtoBuilder = exports.ImageDtoBuilder = void 0;
var offering_location_dto_builder_1 = require("../offering-location/offering-location.dto.builder");
var ImageDtoBuilder = /** @class */ (function () {
    function ImageDtoBuilder() {
        this.image = {
            width: 1000,
            height: 1000,
            relativeUri: 'e320d0_a08d5b3e1b124f6cb9a5c38182079dc6~mv2.jpg',
        };
    }
    ImageDtoBuilder.prototype.withFileName = function (fileName) {
        this.image.fileName = fileName;
        return this;
    };
    ImageDtoBuilder.prototype.withRelativeUri = function (relativeUri) {
        this.image.relativeUri = relativeUri;
        return this;
    };
    ImageDtoBuilder.prototype.withHeight = function (height) {
        this.image.height = height;
        return this;
    };
    ImageDtoBuilder.prototype.withWidth = function (width) {
        this.image.width = width;
        return this;
    };
    ImageDtoBuilder.prototype.build = function () {
        return this.image;
    };
    return ImageDtoBuilder;
}());
exports.ImageDtoBuilder = ImageDtoBuilder;
var OfferingInfoDtoBuilder = /** @class */ (function () {
    function OfferingInfoDtoBuilder() {
        this.info = {
            name: 'Nice Offering',
            description: 'This offering is awesome',
            tagLine: 'Service, Offering, Serlass',
            images: [new ImageDtoBuilder().build()],
            locations: [new offering_location_dto_builder_1.OfferingLocationDtoBuilder().build()],
        };
    }
    OfferingInfoDtoBuilder.prototype.withName = function (name) {
        this.info.name = name;
        return this;
    };
    OfferingInfoDtoBuilder.prototype.withDescription = function (description) {
        this.info.description = description;
        return this;
    };
    OfferingInfoDtoBuilder.prototype.withTagLine = function (tagLine) {
        this.info.tagLine = tagLine;
        return this;
    };
    OfferingInfoDtoBuilder.prototype.withImages = function (image) {
        this.info.images = [image];
        return this;
    };
    OfferingInfoDtoBuilder.prototype.withLocations = function (locations) {
        this.info.locations = locations;
        return this;
    };
    OfferingInfoDtoBuilder.prototype.build = function () {
        return this.info;
    };
    return OfferingInfoDtoBuilder;
}());
exports.OfferingInfoDtoBuilder = OfferingInfoDtoBuilder;
//# sourceMappingURL=offering-info.dto.builder.js.map